import React from 'react';

type Props = {
  value: boolean | null | undefined;
};

export default function BooleanTag({ value }: Props) {
  return (
    <span className="badge px-2 py-4 rounded-4 text-12 text-white" style={{ backgroundColor: value ? '#096609' : '#ae0b0b' }}>
      {value ? 'Yes' : 'No'}
    </span>
  );
}
